import { useLocale } from '@ecomm/data-hooks'
import { formatPrice } from '@simplisafe/eis-commercetools-shared'
import type { ShippingMethod } from '@simplisafe/eis-commercetools-shipping-methods'

import { RadioItem } from '../FormRadioItem'

type Props = {
  readonly data: ShippingMethod
}

export function Option({ data }: Props) {
  const locale = useLocale()
  const formattedPrice = formatPrice(data.price, locale)

  return (
    <div className="border-0 text-left text-base" data-component="Option">
      <RadioItem
        description={formattedPrice}
        key={data.id}
        label={data.name.replace('business', 'bus.')}
        name="shippingOption"
        sublabel={data.description || ''}
        value={data.id}
      />
    </div>
  )
}
